<sn-drawer *ngIf="this.allowAi">
  <sn-drawer-header [title]="'common.searchDetections' | t">
    <sn-icon-button icon="close" snDrawerClose snDrawerNavButton></sn-icon-button>
  </sn-drawer-header>
  <ng-template [ngIf]="isLoading || isUpdatingFacets">
    <div class="progress-message">
      {{ progressMessage }}
      <span *ngIf="progressMessage" class="ellipsis-anim">
        <span>.</span><span>.</span><span>.</span></span
      >
    </div>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </ng-template>
  <sn-drawer-content>
    <form [formGroup]="form" (ngSubmit)="submitForm()">
      <sn-form [form]="form" [fields]="formFields" [model]="formModel"></sn-form>
      <ngx-slider
        #timeSlider
        [(value)]="startTime"
        [(highValue)]="endTime"
        [options]="sliderOptions"
      ></ngx-slider>
    </form>
  </sn-drawer-content>
  <div class="actions">
    <sn-flat-button color="info" (click)="viewResults()" type="button" [disabled]="form.invalid">
      {{ 'common.viewResults' | t }}
    </sn-flat-button>
    <sn-flat-button
      color="success"
      (click)="openCreateSentryDialog()"
      [disabled]="form.invalid"
      snDrawerClose
    >
      {{ 'map.snapAiSelector.createSentry' | t }}
    </sn-flat-button>
    <sn-flat-button
      color="danger"
      (click)="resetForm()"
      type="button"
      [disabled]="!form.value.label"
    >
      {{ 'common.clearFilters' | t }}
    </sn-flat-button>
  </div>
</sn-drawer>
